import { Card, createStyles, Theme, Toolbar } from "@material-ui/core";
import {
  FormFields,
  OneDataSource,
  PresentationComponentProps,
  RouterStore
} from "../../index";
import React from "react";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/styles";

import { Variant } from "@material-ui/core/styles/createTypography";
import { ReactNode } from "react";

export interface ViewProps {
  title?: string;
  prefix?: ReactNode | false;
  titleVariant?: Variant;
  viewContainer?: any;
  titleContainer?: any;
  contentContainer?: any;
}

export interface OneViewProps<T, ID> extends ViewProps {
  dataSource: OneDataSource<T, ID>;
  fields: FormFields;
  goBack?: (response?: any) => void;
  router?: RouterStore;
  titleRow?: false;
  Presentation?: React.FunctionComponent<PresentationComponentProps>;
}

export const viewStyles = (theme: Theme) =>
  createStyles({
    title: {},
    titleButtons: {
      marginLeft: theme.spacing(1) * 2
    },
    titleText: {},
    card: {
      maxWidth: "800px",
      marginBottom: theme.spacing(1)
    },
    submitButton: {
      justifySelf: "end",
      marginTop: theme.spacing(1) * 3,
      width: "200px"
    },
    largeIcon: {
      fontSize: "35px"
    }
  });

const useStyles = makeStyles(viewStyles);

export const DefaultViewContainer = ({ children }: any) => {
  return <div>{children}</div>;
};

export const DefaultTitleContainer = ({ children }: any) => {
  return <Toolbar disableGutters>{children}</Toolbar>;
};

export const DefaultContentContainer = ({ children }: any) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>{children}</CardContent>
    </Card>
  );
};

export const DefaultDataTableContainer = ({ children }: any) => {
  return <Card>{children}</Card>;
};
